import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

// Bouton flottant de retour en haut : les sets font plusieurs centaines de
// cartes, remonter à la main est pénible. N'apparaît qu'une fois qu'on a
// vraiment descendu, pour ne pas encombrer l'écran le reste du temps.
export const ScrollToTop = ({ threshold = 500 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      title="Revenir en haut"
      aria-label="Revenir en haut"
      className="scroll-to-top-btn w-11 h-11 rounded-full bg-zinc-800/95 hover:bg-zinc-700 text-white border border-zinc-700 shadow-xl flex items-center justify-center"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
};
